import { render, staticRenderFns } from "./ModalDownloadTicket.vue?vue&type=template&id=64d9e736&"
import script from "./ModalDownloadTicket.vue?vue&type=script&lang=js&"
export * from "./ModalDownloadTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports